"use client";

// Isolated so the onClick handler lives inside a Client Component. The root
// layout_is_a_Server_Component, and passing an element tree containing an
// event handler as the ErrorBoundary `fallback` prop caused Next.js_to try to
// serialize the function across the server→client boundary
// ("Event handlers cannot be passed to Client Component props").
export default function ReloadButton() {
  return (
    <button
      onClick={() => window.location.reload()}
      className="px-6 py-3 bg-y text-black font-black text-xs uppercase tracking-[0.2em] rounded-xl hover:opacity-90"
    >
      Reload
    </button>
  );
}
